
<transition name="fade">
    <div :class="$style.root" ref="poppercontent" v-show="meta.active">
        <slot></slot>
    </div>
</transition>
